<main
  class="login-page-wrapper"
>
  <section
    class="branding-panel"
  >
    <a
      class="branding-logo-tile"
      routerLink="/login"
    >
      <img
        class="branding-logo-img"
        src="assets/logos/pi-signage-full-logo.svg"
        alt="PI Signage"
      >
    </a>
    <div
      class="branding-content"
    >
      <p
        class="branding-tag"
      >
        Digital signage management
      </p>
      <h1
        class="branding-heading"
      >
        Manage every display from one workspace.
      </h1>
      <p
        class="branding-subtext"
      >
        A focused SaaS foundation for organizations, users, roles, and secure access.
      </p>
    </div>
  </section>

  <section
    class="login-panel"
  >
    <div
      class="login-card"
    >
      <span
        class="login-welcome"
      >
        Welcome back
      </span>
      <h2
        class="login-title"
      >
        Sign in
      </h2>
      <p
        class="login-description"
      >
        Use your organization account.
      </p>

      <div
        class="auth-method-tabs"
        role="tablist"
        aria-label="Sign-in method"
      >
        <button
          class="auth-method-tab"
          type="button"
          role="tab"
          [class.active]="loginMode === 'password'"
          [attr.aria-selected]="loginMode === 'password'"
          (click)="selectLoginMode('password')"
        >
          Password
        </button>
        <button
          class="auth-method-tab"
          type="button"
          role="tab"
          [class.active]="loginMode === 'otp'"
          [attr.aria-selected]="loginMode === 'otp'"
          (click)="selectLoginMode('otp')"
        >
          OTP
        </button>
      </div>

      <form
        *ngIf="loginMode === 'password'"
        #loginForm="ngForm"
        (ngSubmit)="onSubmit()"
      >
        <div
          class="login-field-group"
        >
          <label
            for="loginEmail"
          >
            Email
          </label>
          <input
            pInputText
            class="login-input"
            id="loginEmail"
            name="email"
            type="email"
            autocomplete="email"
            [(ngModel)]="email"
            required
          >
        </div>

        <div
          class="login-field-group"
        >
          <label
            for="loginPassword"
          >
            Password
          </label>
          <input
            pInputText
            class="login-input"
            id="loginPassword"
            name="password"
            type="password"
            autocomplete="current-password"
            [(ngModel)]="password"
            required
          >
        </div>

        <p
          *ngIf="errorMessage"
          class="alert error"
          role="alert"
        >
          {{ errorMessage }}
        </p>

        <button
          class="login-btn login-btn-primary"
          type="submit"
          [disabled]="loginForm.invalid || isSubmitting"
        >
          {{ isSubmitting ? 'Signing in…' : 'Sign in' }}
        </button>
      </form>

      <form
        *ngIf="loginMode === 'otp'"
        #otpForm="ngForm"
        (ngSubmit)="onSubmit()"
      >
        <div
          class="login-field-group"
        >
          <label
            for="loginOtpEmail"
          >
            Email
          </label>
          <input
            pInputText
            class="login-input"
            id="loginOtpEmail"
            name="otpEmail"
            type="email"
            autocomplete="email"
            [(ngModel)]="email"
            [disabled]="otpRequested"
            required
          >
        </div>

        <button
          *ngIf="!otpRequested"
          class="login-btn login-btn-primary"
          type="button"
          [disabled]="!email || isRequestingOtp"
          (click)="requestOtp()"
        >
          {{ isRequestingOtp ? 'Sending…' : 'Request OTP' }}
        </button>

        <ng-container
          *ngIf="otpRequested"
        >
          <div
            class="login-field-group"
          >
            <label
              for="loginOtp"
            >
              One-time password
            </label>
            <input
              pInputText
              class="login-input otp-input"
              id="loginOtp"
              name="otp"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              [(ngModel)]="otp"
              minlength="4"
              maxlength="4"
              pattern="[0-9]{4}"
              required
            >
          </div>

          <p
            *ngIf="successMessage"
            class="alert success"
            role="status"
          >
            {{ successMessage }}
          </p>

          <p
            *ngIf="errorMessage"
            class="alert error"
            role="alert"
          >
            {{ errorMessage }}
          </p>

          <button
            class="login-btn login-btn-primary"
            type="submit"
            [disabled]="otpForm.invalid || isSubmitting"
          >
            {{ isSubmitting ? 'Signing in…' : 'Verify and sign in' }}
          </button>

          <button
            class="auth-text-button"
            type="button"
            [disabled]="isRequestingOtp"
            (click)="requestOtp()"
          >
            Resend code
          </button>
        </ng-container>

        <p
          *ngIf="errorMessage && !otpRequested"
          class="alert error"
          role="alert"
        >
          {{ errorMessage }}
        </p>
      </form>

      <div
        class="auth-links single"
      >
        <a
          routerLink="/forgot-password"
        >
          Forgot password?
        </a>
      </div>
    </div>
  </section>
</main>
